/**
 * inCust API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface TransactionErrorsApiModel {
  /**
   * Error code
   */
  code?: string;
  /**
   * Error level
   */
  level?: TransactionErrorsApiModelLevelEnum;
  /**
   * Error message
   */
  message?: string;
  /**
   * Error type
   */
  type?: TransactionErrorsApiModelTypeEnum;
}
export enum TransactionErrorsApiModelLevelEnum {
  Warning = 'warning',
  Error = 'error'
}
export enum TransactionErrorsApiModelTypeEnum {
  AuthorizedPaymentCapture = 'authorized-payment-capture',
  TransactionPostProcessing = 'transaction-post-processing'
}
